import { columnKeyMap } from './columnKeyMap';
import { sortTypes } from './sortTypes';

const {
  brand,
  number,
  region,
  country,
  permit,
  clients,
  permitType,
  clientFio,
  permitStatus,
  insertDate,
  entryDate,
  expireDate,
  isRepeatPermit,
  houseNamePermit,
  sourcePermit,
  hasPermits,
  transportType,
} = columnKeyMap;

export const sortableColumnsData = {
  [brand]: [{ name: brand, type: sortTypes.string }],
  [number]: [{ name: number, type: sortTypes.string }],
  [region]: [{ name: region, type: sortTypes.number }],
  [country]: [{ name: country, type: sortTypes.string }],
  [permit]: [{ name: permit, type: sortTypes.string }],
  [clients]: [{ name: permit, type: sortTypes.arrLength }],
  [permitType]: [{ name: permitType, type: sortTypes.string }],
  [clientFio]: [{ name: clientFio, type: sortTypes.string }],
  [permitStatus]: [{ name: permitStatus, type: sortTypes.string }],
  [insertDate]: [{ name: insertDate, type: sortTypes.date }],
  [entryDate]: {
    [entryDate]: [{ name: entryDate, type: sortTypes.date }],
    [expireDate]: [{ name: expireDate, type: sortTypes.date }],
  },
  [isRepeatPermit]: [{ name: isRepeatPermit, type: sortTypes.string }],
  [houseNamePermit]: [{ name: houseNamePermit, type: sortTypes.string }],
  [sourcePermit]: [{ name: sourcePermit, type: sortTypes.string }],
  [hasPermits]: [{ name: hasPermits, type: sortTypes.string }],
  [transportType]: [{ name: transportType, type: sortTypes.string }],
};
